export function updateFavicon(count) {
  if (!window.theme.favicon) return;

  const faviconMetaTag = document.querySelector('[rel*="icon"]');

  if (!faviconMetaTag) return;

  const faviconUrl = window.theme.favicon;

  /**
   * Create a temporary canvas element where we will draw the image and badge.
   */
  const canvasElement = document.createElement('canvas');
  canvasElement.width = 32;
  canvasElement.height = 32;

  /**
   * Create a temporary image element that holds the favicon image.
   */
  const imgElement = document.createElement('img');
  imgElement.setAttribute('crossorigin', 'anonymous');

  /**
   * When the image is loaded in the browser, render the favicon, render the badge and set the favicon.
   */
  imgElement.onload = function() {
    const ctx = canvasElement.getContext('2d');

    ctx.drawImage(imgElement, 0, 0);

    /**
     * Draw a badge only if the cart is not empty.
     */
    if (count > 0) {
      ctx.beginPath();
      const centerX = canvasElement.width - (canvasElement.width / 6);
      const centerY = (canvasElement.width / 6);
      const radius = (canvasElement.width / 6);
      ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
      ctx.fillStyle = '#E02020';
      ctx.fill();
    }

    faviconMetaTag.href = canvasElement.toDataURL('image/png');
  };

  imgElement.setAttribute('src', faviconUrl);
}
